import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'servicos/servicos',
		component: Base,
		children: [
			{
				path: '',
				name: 'ServicosList',
				component: List,
				meta: {
					path: '/servicos/servicos',
					pai: 'Serviços',
					title: 'Admin - Serviços',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Serviços',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'ServicosNovo',
				component: Form,
				meta: {
					path: '/servicos/servicos',
					pai: 'Serviços',
					title: 'Admin - Serviços - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Serviços',
						class: '',
						active: false,
						url: '/servicos/servicos'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'ServicosEditar',
				component: Form,
				meta: {
					path: '/servicos/servicos',
					pai: 'Serviços',
					title: 'Admin - Serviços - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Serviços',
						class: '',
						active: false,
						url: '/servicos/servicos'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]